module.exports = __webpack_public_path__ + "img/title3.c6a97739.png";